var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "MainMenuView",
    {
      attrs: { title: "Taxes" },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("h3", [_vm._v("Taxes")]),
      _c(
        "div",
        { staticClass: "d-flex justify-content-between" },
        [
          _c("label", [_vm._v("Nexus States")]),
          _c(
            "b-btn",
            { attrs: { variant: "primary" }, on: { click: _vm.addState } },
            [_vm._v("Add State")]
          ),
        ],
        1
      ),
      _vm.loading
        ? _c("i", { staticClass: "far fa-spinner-third fa-spin" })
        : _c("NexusStatesTable", {
            ref: "nexusStatesTable",
            attrs: {
              states: _vm.store.nexusStates,
              availableStates: _vm.availableStates,
              loading: _vm.loading,
            },
            on: { remove: _vm.handleRemove, submit: _vm.handleSubmit },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }